<template>
  <div>
    <template v-for="(deck, deckIndex) in data.seat_map.data.decks">
      <div :key="'deck' + deckIndex" class="d-flex flex-column align-items-center">
        <h5 class="package-title font-weight-bold border-bottom pb-2 text-primary border-primary w-100 text-center">{{ deck.deckName }}</h5>
        <table>
          <tr v-for="rowIndex in deck.rows" :key="'row' + rowIndex">
            <td v-for="colIndex in deck.cols" :key="'col' + colIndex" style="text-align: center; vertical-align: middle;">
              <Seat
                :data="getSlotInfo(deckIndex, rowIndex, colIndex)"
                :occupied="isOccupied(deckIndex, rowIndex, colIndex)"
                :pax="selectedPaxForSeat(deckIndex, rowIndex, colIndex)"
                @select="onSeatSelect(deckIndex, rowIndex, colIndex)"
                />
            </td>
          </tr>
        </table>
      </div>
    </template>
    <hr class="my-2 border-primary">
    <div class="d-flex px-2">
      <div class="d-flex mr-3 align-items-center">
        <div style="width: .87rem; height: .87rem; background-color: #55c40a; border-radius: 3px; margin-right: .35rem;"></div>
        <small><strong>Loc liber</strong></small>
      </div>
      <div class="d-flex align-items-center">
        <div style="width: .87rem; height: .87rem; background-color: #435d80; border-radius: 3px; margin-right: .35rem;"></div>
        <small><strong>Loc ocupat</strong></small>
      </div>
    </div>
    <hr class="my-2 border-primary">
    <template v-for="(room, roomIndex) in pax">
      <template v-for="(pax, paxIndex) in room">
        <Pax
          :key="'pax_' + roomIndex + '_' + paxIndex"
          :pax="pax"
          :roomIndex="roomIndex"
          :paxIndex="paxIndex"
          :selectedSlot="selectedSeatForPax(pax)"
          :isSelected="selectedPax === pax"
          @select="selectedPax = pax"
          />
      </template>
    </template>
  </div>
</template>

<script>
import Seat from './seat_map_slot.vue'
import Pax from './seat_map_pax.vue'

export default {
  props: {
    data: {
      type: Object,
      required: true
    },
    pax: {
      type: Array,
      required: true
    }
  },
  components: { Seat, Pax },
  data () {
    return {
      selectedPax: null
    }
  },
  methods: {
    getSlotInfo (deckIndex, rowIndex, colIndex) {
      const deck = this.data.seat_map.data.decks[deckIndex]
      const slot = deck.slots.find(el => (el.col === colIndex) && (el.row === rowIndex + deck.startingRowNo - 1))
      return slot
    },
    isOccupied (deckIndex, rowIndex, colIndex) {
      const deck = this.data.seat_map.data.decks[deckIndex]
      return this.data.seats_taken.some(el => (el.col === colIndex) && (el.row === rowIndex + deck.startingRowNo - 1))
    },
    selectedPaxForSeat (deckIndex, rowIndex, colIndex) {
      const deck = this.data.seat_map.data.decks[deckIndex]
      const paxList = this.pax.flatMap(room => room)
      const pax = paxList
        .find(pax => pax.seatSelections
          .some(p => (p.col === colIndex) && (p.row === rowIndex + deck.startingRowNo - 1) && (p.element === this.data.element) && (p.direction === this.data.direction))
        )
      return pax || null
    },
    selectedSeatForPax (pax) {
      if (!pax.seatSelections) {
        return null
      }
      const seat = this.data.seat_map.data.decks
        .flatMap(deck => deck.slots)
        .find(slot => pax.seatSelections.some(p => (p.col === slot.col) && (p.row === slot.row) && (p.element === this.data.element) && (p.direction === this.data.direction)))
      return seat || null
    },
    onSeatSelect (deckIndex, rowIndex, colIndex) {
      if (!this.selectedPax) {
        return
      }
      if (this.isOccupied(deckIndex, rowIndex, colIndex)) {
        return
      }
      if (!this.selectedPax.seatSelections) {
        this.$set(this.selectedPax, 'seatSelections', [])
      }
      const deck = this.data.seat_map.data.decks[deckIndex]
      const info = this.getSlotInfo(deckIndex, rowIndex, colIndex)
      if (!info) {
        return
      }
      if (info.status === 'unavailable') {
        return
      }
      const existingIndex = this.selectedPax.seatSelections.findIndex(entry => (entry.element === this.data.element) && (entry.direction === this.data.direction))
      if (existingIndex >= 0) {
        this.selectedPax.seatSelections.splice(existingIndex, 1)
      }

      this.selectedPax.seatSelections.push({
        element: this.data.element,
        direction: this.data.direction,
        col: colIndex,
        row: rowIndex + deck.startingRowNo - 1,
        label: this.getSlotInfo(deckIndex, rowIndex, colIndex).label
      })
    }
  }
}
</script>
